import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Row, Card, Skeleton } from 'antd';
import OneRowData from 'components/OneRowData';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import { formatDateTime } from 'shared/utils/StringUtil';

import auditRoute from '../../route';
import text from './AuditDetail.page.translation';

import './AuditDetail.style.less';

export class AuditDetail extends Component {
  componentDidMount() {
    const { id } = this.props.match.params;

    this.props.data.refetch({ id });
  }

  _renderInfo = () => {
    const {
      intl: { formatMessage },
      data: { loading },
      data,
    } = this.props;

    return (
      <div className="card-section">
        <Card title={formatMessage(text.info)}>
          <Row type="flex">
            <Card.Grid style={{ padding: '16px' }}>
              <Skeleton
                loading={loading}
                active
                paragraph={{ rows: 1, width: ['100%', '100%'] }}
                title={false}
              >
                <OneRowData
                  data={{
                    label: formatMessage(text.employe),
                    value: `${get(data, 'log[0].user.firstname')} ${get(
                      data,
                      'log[0].user.lastname',
                    )}`,
                  }}
                />
                <OneRowData
                  data={{
                    label: formatMessage(text.company),
                    value: get(data, 'log[0].user.organization_name'),
                  }}
                />
                <OneRowData
                  data={{
                    label: formatMessage(text.date),
                    value: formatDateTime(
                      get(data, 'log[0].request_detail.remote_timestamp'),
                    ),
                  }}
                />
              </Skeleton>
            </Card.Grid>
            <Card.Grid style={{ padding: '16px' }}>
              <Skeleton
                loading={loading}
                active
                paragraph={{ rows: 1, width: ['100%', '100%'] }}
                title={false}
              >
                <OneRowData
                  data={{
                    label: formatMessage(text.module),
                    value: get(data, 'log[0].service'),
                  }}
                />
                <OneRowData
                  data={{
                    label: formatMessage(text.action),
                    value: get(data, 'log[0].operation_type'),
                  }}
                />
              </Skeleton>
            </Card.Grid>
          </Row>
        </Card>
      </div>
    );
  };

  _renderUpdateDesc = () => {
    const { data } = this.props;
    const oldValue = get(data, 'log[0].value_old.columns.payload', {});
    const newValue = get(data, 'log[0].value_new.columns', {});

    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', paddingTop: '16px' }}
      >
        {Object.keys(oldValue).map(item => (
          <span className="description">
            Parameter Name: <span className="info">{item}</span> = Old Value:{' '}
            <span className="info">{get(oldValue, item, 'null')}</span>, New
            Value: <span className="info">{get(newValue, item, 'null')}</span>
          </span>
        ))}
      </div>
    );
  };

  _renderDesc = () => {
    const {
      data: { loading },
      intl: { formatMessage },
      data,
    } = this.props;
    const name = `${get(data, 'log[0].user.firstname')} ${get(
      data,
      'log[0].user.lastname',
    )}`;
    const company = `${get(data, 'log[0].user.organization_name')}`;
    const action = get(data, 'log[0].operation_type');
    const module = get(data, 'log[0].service');

    const time = formatDateTime(
      get(data, 'log[0].request_detail.remote_timestamp'),
    );
    return (
      <div className="card-section-company">
        <Card title={formatMessage(text.desc)}>
          <div style={{ padding: '16px' }}>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 1, width: ['100%', '100%'] }}
              title={false}
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="description">
                  <span className="info">{name}</span> from{' '}
                  <span className="info">{company}</span>
                </span>
                <span className="description">
                  <span className="info">{action}</span> on{' '}
                  <span className="info">{module}</span> at{' '}
                  <span className="info">{time}</span>
                </span>
              </div>

              {action === 'UPDATE' && this._renderUpdateDesc()}
            </Skeleton>
          </div>
        </Card>
      </div>
    );
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    return (
      <div className="main-content">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">{formatMessage(text.home)}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={auditRoute.LIST}>{formatMessage(text.auditList)}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{formatMessage(text.auditDetail)}</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <span className="title topup-wrapper">
            {formatMessage(text.auditDetail)}
          </span>

          <div className="audit-detail-wrapper">
            {this._renderInfo()}
            {this._renderDesc()}
          </div>
        </div>
      </div>
    );
  }
}

AuditDetail.propTypes = {
  match: PropTypes.object,
  intl: PropTypes.object.isRequired,
  data: PropTypes.object,
};

export default AuditDetail;
